import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { IndexLabel, SemaphoreGroup } from './semaphors';
import ResponsiveTable from '../layoutItems/responsiveTable';
import AmlExplanatoryNotes from '../reportSections/aml/amlExplanatoryNotes';
import { SECTIONS } from '../../store/reportStore';

import Bad from '../../img/quality/bad';
import Worse from '../../img/quality/worse';
import Neutral from '../../img/quality/neutral';
import Better from '../../img/quality/better';
import Good from '../../img/quality/good';

import './popover.scss';

const bbPopoverToggleOnEvents = {
    toggleOnClick: "toggleOnClick",
    toggleOnMouse: "toggleOnMouse",
    toggleNever: "toggleNever"
};

class BbPopover extends React.Component {
    state = {
        popoverOpen: false,
        isAfterFirstToggle: false
    };

    timer = null;
    timerSet = false;

    render() {
        return (
            <React.Fragment>
                {React.cloneElement(this.props.children, this.toggleOnEvent(this.props.toggleOnEvent))}
                <Popover
                    className={classnames({ 'popover-wide': this.widePopover(this.props.addInfo) })}
                    placement={this.props.placement}
                    isOpen={this.state.popoverOpen}
                    target={this.props.targetId}
                    toggle={() => this.toggle(!this.state.popoverOpen)}
                    boundariesElement="window"
                >
                    {this.props.title && <PopoverHeader>{this.props.title}</PopoverHeader>}
                    <PopoverBody>
                        {this.props.contentAsTranslateId ? 
                        //if content is translateId 
                        <div className="popover-info">{ReactHtmlParser(this.props.translate(this.props.content))}</div>
                        //else if content is text
                        : <div className="popover-info">{this.props.content}</div>}
                        {this.props.addInfo && <div className="popover-additional-info">
                            {this.returnAddInfo(this.props.addInfo)}
                        </div>}
                    </PopoverBody>
                </Popover>
            </React.Fragment>
        )
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    toggle = (value) => {
        if (this.props.withDelayAfterFirstToggle && !this.timerSet) {
            this.timerSet = true;
            clearTimeout(this.timer);
            this.timer = setTimeout(() => { this.setState({ isAfterFirstToggle: true }) }, 2000);
        } else if (this.timerSet && !this.state.isAfterFirstToggle) {
            return;
        } else {
            this.setState({ popoverOpen: value });
        }
    }

    toggleOnEvent = (toggleOnEvent) => {
        switch (toggleOnEvent) {
            case bbPopoverToggleOnEvents.toggleOnMouse:
                return { onMouseEnter: () => this.toggle(true), onMouseLeave: () => this.toggle(false) };
            case bbPopoverToggleOnEvents.toggleNever:
                return;
            case bbPopoverToggleOnEvents.toggleOnClick:
            default:
                return { onClick: () => this.toggle(!this.state.popoverOpen) };
        }
    }

    widePopover = (addInfo) => {
        switch (addInfo) {
            case "IndexCribis":
            case "Semaphore":
            case "PaymentDiscipline":
            case "SelectedFinancialRatios":
            case "AmlGlobalEval":
            case "ESS":
                return true;
            default:
                return false;
        }
    }

    returnAddInfo = (addInfo) => {
        switch (addInfo) {
            case "IndexCribis":
                return this.cribisIndexInfo();
            case "Semaphore":
                return this.semaphoreInfo();
            case "PaymentDiscipline":
                return this.paymentDisciplineInfo();
            case "SelectedFinancialRatios":
                return this.selectedFinancialRatiosInfo();
            case "AmlGlobalEval":
                return this.amlGlobalEval();
            case "ESS":
                return this.ess();
            default:
                break;
        }
    }

    getEssData = () => (this.props.sections.find(i => i.id === SECTIONS.economicGroupEvaluation) || {}).data;

    ess = () => {
        let data = this.getEssData();
        return (
            <ResponsiveTable  useSticky style={{ maxHeight: "400px" }}>

            {data.infoTables.map((table, index) => (

                    <table className="table table-report-section sticky-table">
                    <thead>
                        <tr>
                            <th style={{ width: "50%" }} colSpan={2}>{table.infoSectionName}</th>
                            <th style={{ width: "50%" }}>{table.descriptionSectionName}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {table.rows.map((row) => (
                            <tr>
                                <td style={{ width: "15%" }}>{row.mark}</td>
                                <td style={{ width: "35%" }}>{row.shortening}</td>
                                <td style={{ width: "50%" }}>{row.description}</td>
                            </tr>

                        ))}

                    </tbody>
                </table>

            ))}
            </ResponsiveTable>
        )
    }

    cribisIndexInfo = () => {
        return (
            <ResponsiveTable useSticky style={{ maxHeight: "400px" }}>
                <table className="table table-report-section sticky-table">
                    <thead>
                        <tr>
                            <th style={{ width: "12%" }}>{ReactHtmlParser(this.props.translate('Report.Ratings.IndexCribis'))}</th>
                            <th style={{ width: "20%" }}>{ReactHtmlParser(this.props.translate('Report.Ratings.Explanatory.Risk'))}</th>
                            <th style={{ width: "34%" }}>{ReactHtmlParser(this.props.translate('Report.Ratings.Explanatory.FinEvalNote'))}</th>
                            <th style={{ width: "34%" }}>{ReactHtmlParser(this.props.translate('Report.Ratings.Explanatory.NonFinEvalNote'))}</th>
                        </tr>
                    </thead>
                    <tbody>{
                        ['a1', 'a2', 'b1', 'b2', 'c1', 'c2', 'c3', 'd1', 'd2', 'e', 'na'].map((ratingCode, index) => (
                            <tr key={ratingCode} className='colorize'>
                                <td style={{ width: "12%" }} data-label={this.props.translate('Report.Ratings.IndexCribis')}>
                                    <IndexLabel code={ratingCode} height='2.4em' padding='0.2em' />
                                </td>
                                <td style={{ width: "20%" }} data-label={this.props.translate('Report.Ratings.Explanatory.Risk')}>
                                    <span>{ReactHtmlParser(this.props.translate(`Report.Ratings.10Star.${10 - index}`))}</span>
                                </td>
                                <td style={{ width: "34%" }} data-label={this.props.translate('Report.Ratings.Explanatory.FinEvalNote')}>
                                    <span>{ReactHtmlParser(this.props.translate(`Report.Ratings.CribisIndexTooltip${10 - index}`))}</span>
                                </td>
                                <td style={{ width: "34%" }} data-label={this.props.translate('Report.Ratings.Explanatory.NonFinEvalNote')}>
                                    <span>{ReactHtmlParser(this.props.translate(`Report.Ratings.Explanatory.NonFin${10 - index}`))}</span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </ResponsiveTable>
        )
    }

    semaphoreInfo = () => {
        return (
            <>
                <ResponsiveTable useSticky style={{ maxHeight: "400px" }}>
                    <table className="table table-report-section sticky-table">
                        <thead>
                            <tr>
                                <th style={{ width: "30%" }}>{ReactHtmlParser(this.props.translate('Report.Ratings.SemaphoreCribis'))}</th>
                                <th style={{ width: "70%" }}>{ReactHtmlParser(this.props.translate('Report.Common.Note'))}</th>
                            </tr>
                        </thead>
                        <tbody>{
                            ['Na', 'Plus', 'Neutral', 'Minus'].map((semaphore, index) => (
                                <tr key={semaphore} className='colorize'>
                                    <td style={{ width: "30%" }} className='always-new-line' data-label={this.props.translate('Report.Ratings.SemaphoreCribis')}>
                                        <SemaphoreGroup value={index} size='medium' className='explanatory' />
                                    </td>
                                    <td style={{ width: "70%" }} data-label={this.props.translate('Report.Common.Note')}>
                                        <span>
                                            {ReactHtmlParser(this.props.translate(`Report.Ratings.Explanatory.SemaphoreCribis${semaphore}${this.getRatingData().country}`))}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </ResponsiveTable>
            </>
        )
    }

    getRatingData = () => (this.props.sections.find(i => i.id === SECTIONS.ratingData || i.id === SECTIONS.shortReportRatingData || i.id ===  SECTIONS.mirriRatingData) || {}).data;

    renderExplanatoryDescription = translationId => (<>
        <br />
        <hr className='no-margin' />
        <span>{ReactHtmlParser(this.props.translate(`${translationId}`))}</span>
        <hr className='no-margin' />
    </>)
    generatePaymentDisciplineArray = () => [
        { id: 'AAA', subIndexes: ['+', '', '-'] },
        { id: 'AA', subIndexes: ['+', '', '-'] },
        { id: 'A', subIndexes: ['+', '', '-'] },
        { id: 'BBB', subIndexes: ['+', '', '-'] },
        { id: 'BB', subIndexes: ['+', '', '-'] },
        { id: 'B', subIndexes: ['+', '', '-'] },
        { id: 'CCC', subIndexes: ['+', '', '-'] },
        { id: 'CC', subIndexes: ['+', '', '-'] },
        { id: 'C', subIndexes: ['+', '', '-'] },
        { id: 'D', subIndexes: [''] }
    ];

    paymentDisciplineInfo = () => {
        return (
            <>
                {this.getRatingData().country === 'SK' && (<>
                    <ResponsiveTable useSticky style={{ maxHeight: "400px" }}>
                        <table className="table table-report-section sticky-table payment-discipline-info-table">
                            <thead>
                                <tr>
                                    <th style={{ width: "30%" }}>{ReactHtmlParser(this.props.translate('Report.Ratings.PaymentDisciplineIndex'))}</th>
                                    <th style={{ width: "70%" }}>{ReactHtmlParser(this.props.translate('Report.Common.Note'))}</th>
                                </tr>
                            </thead>
                            <tbody>{
                                this.generatePaymentDisciplineArray().map(index => index.subIndexes.map((subIndex, arrayIndex) => (
                                    <tr key={`${index.id}${subIndex}`}>
                                        <td style={{ width: "30%" }} data-label={this.props.translate('Report.Ratings.PaymentDisciplineIndex')}>
                                            <span>{`${index.id}${subIndex}`}</span>
                                        </td>
                                        {arrayIndex === 0 &&
                                            <td style={{ width: "70%" }} rowSpan={index.subIndexes.length} data-label={this.props.translate('Report.Common.Note')}>
                                                <span>{ReactHtmlParser(this.props.translate(`Report.Ratings.Explanatory.PaymentDiscipline${index.id}`))}</span>
                                            </td>}
                                        {arrayIndex !== 0 && 
                                            <td className="payment-discipline-info-mobile-row" style={{ width: "70%" }}
                                                rowSpan={index.subIndexes.length} data-label={this.props.translate('Report.Common.Note')}
                                            >
                                                <span>{ReactHtmlParser(this.props.translate(`Report.Ratings.Explanatory.PaymentDiscipline${index.id}`))}</span>
                                            </td>}
                                    </tr>
                                )))
                            }</tbody>
                        </table>
                    </ResponsiveTable>
                </>)}
            </>
        )
    }

    selectedFinancialRatiosInfo = () => {
        return (
            <>
                <ResponsiveTable useSticky style={{ maxHeight: "400px" }}>
                    <table className="table table-report-section sticky-table">
                        <tbody>
                            {[
                                { id: "Good", indicator: <Good />, description: "WellAboveAverage" },
                                { id: "Better", indicator: <Better />, description: "AboveAverage" },
                                { id: "Neutral", indicator: <Neutral />, description: "Average" },
                                { id: "Worse", indicator: <Worse />, description: "BelowAverage" },
                                { id: "Bad", indicator: <Bad />, description: "WellBelowAverage" }
                            ].map((item) => (
                                <tr key={item.id} className='colorize'>
                                    <td style={{ width: "30%" }}>
                                        <div className="fin-stat-quality-indicator-popup">
                                            {item.indicator}
                                        </div>
                                    </td>
                                    <td style={{ width: "70%" }}>
                                        <span>
                                            {ReactHtmlParser(this.props.translate(`Report.Ratings.Explanatory.SelectedFinancialRatiosIndicatorDesc.${item.description}`))}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </ResponsiveTable>
            </>
        )
    }

    amlGlobalEval = () => {
        return (
            <AmlExplanatoryNotes translate={this.props.translate} data={this.props.amlData} />
        );
    }
}

export default withLocalize(connect(state => state.report)(BbPopover));
